import { sendMessage } from '../../../config/utils/message'
import { CORE_API_AKADEMIK } from '../../key/api'

export async function getTranskrip(data) {
    try {
        const response = await CORE_API_AKADEMIK.get('transkip', { params: data })
        return response
    }
    catch (err) {
        sendMessage(500)
    }
}

export async function SemesterTranskip(nim) {

    try {
        const response = await CORE_API_AKADEMIK.get('semester/transkip'+ '?nim=' + nim)
        return response
    }
    catch (err) {
        sendMessage(500)
    }
}

export async function DataTranskrip(nim) {

    try {
        const response = await CORE_API_AKADEMIK.get('pengajuankrs/data/view'+ '?nim=' + nim)
        return response
    }
    catch (err) {
        sendMessage(500)
    }
}